<template>
  <div
    class="card d-inline-block text-center flex-grow-1"
    :role="canOnlyRegister ? 'button' : undefined"
    @click="canOnlyRegister ? navigateToTravel() : null"
  >
    <div v-if="participation.travel.mainPicture?.key">
      <img v-if="participation.travel.titleBanner?.key"
        :src="getPictureUrl(participation.travel.titleBanner.key,50)"
        class="card-img-top object-fit-contain p-3 position-absolute top-0 w-100 home-card-travel-logo"
      >
      <img
        :src="getPictureUrl(participation.travel.mainPicture.key,undefined,450)"
        class="card-img-top object-fit-cover"
        style="object-position: center top;height: 25vh;"
      >
    </div>
    <div v-else-if="participation.travel.titleBanner?.key">
      <img
        :src="getPictureUrl(participation.travel.titleBanner.key,50)"
        class="card-img-top object-fit-contain p-3"
        style="height: 25vh;"
      >
    </div>
    <div v-else>
      <img
        src="@/assets/logo.png"
        class="card-img-top object-fit-contain p-3"
        style="object-position: center center;height: 25vh;"
      >
    </div>
    <div class="card-body d-flex flex-column px-1">
      <div>
        <p class="card-text mb-2">
          {{ participation.travel.name }}
          <br/>
          {{ formatDatePeriod(participation.travel.startDate, participation.travel.endDate, false) }}
        </p>

        <div class="text-success mb-2" v-if="participation.invitation?.completionDate">
          <a role="button" v-if="userStore.connectedUser?.isAdmin" @click="navigateToTravel()"><i class="fa-solid fa-check"></i> Inscrit</a>
          <span v-else><i class="fa-solid fa-check"></i> Inscrit</span>
        </div>
        <div class="text-danger mb-2" v-else-if="participation.invitation?.refusalDate">
          <a role="button" v-if="userStore.connectedUser?.isAdmin" @click="navigateToTravel()"><i class="fa-solid fa-close"></i> Absent</a>
          <span v-else><i class="fa-solid fa-close"></i> Absent</span>

          <p v-if="participation.invitation?.refusalReason" :title="participation.invitation?.refusalReason"><small>( {{ truncate(participation.invitation?.refusalReason) }} )</small></p>
        </div>

        <button class="btn btn-primary" v-if="participation.invitation?.completionDate == null && active">
          Inscription <i class="fa-solid fa-circle-play fa-lg ps-2 align-middle"></i>
        </button>
        <template v-else-if="participation.invitation?.completionDate">
          <div v-if="participation.travel.roadBook?.key && participation.travel.endDate > new Date()">
            <router-link class="btn btn-primary mt-2" :to="{ name: 'travel-roadbook-slug', params: { slug: participation.travel.slug } }">
              Carnet de voyage <i class="fa-solid fa-circle-play fa-lg ps-2 align-middle"></i>
            </router-link>
          </div>
          <div v-else-if="participation.travel.pages && participation.travel.pages.length > 0 && participation.travel.endDate > new Date()">
            <router-link class="btn btn-primary mt-2" :to="{ name: 'travel-pages-slug', params: { slug: participation.travel.slug } }">
              Infos pratiques <i class="fa-solid fa-globe fa-lg ps-2 align-middle"></i>
            </router-link>
          </div>
          <div>
            <router-link class="btn btn-primary mt-2" v-if="participation.travel.endDate > new Date()" :to="{ name: 'travel-summary-slug', params: { slug: participation.travel.slug } }">
              Récapitulatif <i class="fa-solid fa-circle-play fa-lg ps-2 align-middle"></i>
            </router-link>
          </div>
          <div v-if="participation.travel.endDate < new Date()">
            <button class="btn btn-primary mt-2">
              Facture <i class="fa-solid fa-circle-play fa-lg ps-2 align-middle"></i>
            </button>
          </div>
          <div v-if="participation.travel.endDate < new Date()">
            <button class="btn btn-primary mt-2">
              Video <i class="fa-solid fa-circle-play fa-lg ps-2 align-middle"></i>
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { formatDatePeriod, truncate } from '@/compositions/helper';
import { getPictureUrl } from '@/compositions/helper';

const router = useRouter();
const userStore = useUserStore();

const props = defineProps<{
  participation: UserParticipationBasic
}>();

const active = computed(() => {
  return props.participation.travel.endDate > new Date()
    && (props.participation.travel.registrationEndDate > new Date() || userStore.connectedUser?.isAdmin)
    && props.participation.invitation?.refusalDate == null
});

const canOnlyRegister = computed(() => {
  return active.value && props.participation.invitation?.completionDate == null;
});

const navigateToTravel = function () {
  router.push({ name:'travel-slug', params: { slug: props.participation.travel.slug } });
};

</script>
<style>
.home-card-travel-logo {
  max-height: 40%;
}

@media (min-width: 576px) {
  .home-card-travel-logo {
    max-height: 25%;
  }
}
</style>
